import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useState } from "react";
import CartProvider from "./context/CartContext";
import GuestCartProvider from "./context/GuestCartContext";
import GuestCartBridge from "./components/GuestCartBridge";
import GuestToast from "./components/GuestToast";
import AuthModal from "./components/AuthModal";
import Header from "./components/Header/Header";
import HeroSlider from "./components/HeroSlider";
import Wishlist from "./pages/Wishlist";
import Cart from "./pages/Cart";
import GuestCart from "./pages/GuestCart";
import Footer from "./components/Footer/Footer";
import ProductList from "./pages/ProductList";
import About from "./components/About";
import Contact from "./components/Contact";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import PaymentSuccess from "./pages/PaymentSuccess";
import GuestPaymentSuccess from "./pages/GuestPaymentSuccess";
import GuestStripePaymentSuccess from "./pages/GuestStripePaymentSuccess";
import MyOrders from "./pages/MyOrders";
import OrderDetail from "./pages/OrderDetails";
import GuestOrders from "./pages/GuestOrders";
import GuestOrderDetails from "./pages/GuestOrderDetails";
import UserDetail from "./pages/UserDetail";
import CategoriesSection from "./components/CategoriesSection";
import WhyChooseUs from "./components/WhyChooseUs";
import FeaturedProducts from "./components/FeaturedProducts";
import BrandStory from "./components/BrandStory";
import NewArrivals from "./components/NewArrivals";
import Newsletter from "./components/Newsletter";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./components/Checkout";
import GuestCheckout from "./pages/GuestCheckout";

function DefaultLayout({ children }) { return <><Header />{children}<Footer /></>; }
function AdminLayout({ children }) { return <><Header />{children}<Footer /></>; }

function App() {
  const [user, setUser] = useState(() => { const stored = localStorage.getItem("user"); return stored ? JSON.parse(stored) : null; });
  const [showModal, setShowModal] = useState(false);
  const loggedIn = Boolean(user?.access);

  return <CartProvider><GuestCartProvider><GoogleOAuthProvider clientId="546605370258-l8ecnn762q3ftcu7teg7cjlb077534a1.apps.googleusercontent.com"><Router><GuestCartBridge /><GuestToast /><Routes>
    <Route path="/" element={<DefaultLayout><HeroSlider /><CategoriesSection /><WhyChooseUs /><FeaturedProducts /><BrandStory /><NewArrivals /><Newsletter /></DefaultLayout>} />
    <Route path="/home" element={<DefaultLayout><HeroSlider /><CategoriesSection /><WhyChooseUs /><FeaturedProducts /><BrandStory /><NewArrivals /><Newsletter /></DefaultLayout>} />
    <Route path="/aboutus" element={<DefaultLayout><About /></DefaultLayout>} />
    <Route path="/profile" element={<UserDetail />} />
    <Route path="/contact" element={<DefaultLayout><Contact /></DefaultLayout>} />
    <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
    <Route path="/verify-email/:key" element={<VerifyEmail />} />
    <Route path="/favourite" element={<AdminLayout><Wishlist user={user} setShowModal={setShowModal} /></AdminLayout>} />
    <Route path="/payment-success" element={<DefaultLayout><PaymentSuccess /></DefaultLayout>} />
    <Route path="/guest-payment-success" element={<DefaultLayout><GuestPaymentSuccess /></DefaultLayout>} />
    <Route path="/guest-stripe-payment-success" element={<DefaultLayout><GuestStripePaymentSuccess /></DefaultLayout>} />
    <Route path="/orders" element={<DefaultLayout>{loggedIn ? <MyOrders /> : <GuestOrders />}</DefaultLayout>} />
    <Route path="/orders/:orderId" element={<DefaultLayout>{loggedIn ? <OrderDetail /> : <GuestOrderDetails />}</DefaultLayout>} />
    <Route path="/cart" element={<AdminLayout>{loggedIn ? <Cart user={user} setShowModal={setShowModal} /> : <GuestCart />}</AdminLayout>} />
    <Route path="/checkout" element={<AdminLayout>{loggedIn ? <Checkout /> : <GuestCheckout />}</AdminLayout>} />
    <Route path="/products/:category" element={<AdminLayout><ProductList setShowModal={setShowModal} /></AdminLayout>} />
    <Route path="/product/:id" element={<AdminLayout><ProductDetail /></AdminLayout>} />
  </Routes>{showModal && <AuthModal onClose={() => setShowModal(false)} onLoginSuccess={(data) => { const userData = { pk: data.user.pk, username: data.user.username, email: data.user.email, first_name: data.user.first_name, last_name: data.user.last_name, role: data.role, access: data.access, refresh: data.refresh }; setUser(userData); localStorage.setItem("user", JSON.stringify(userData)); setShowModal(false); }} />}</Router></GoogleOAuthProvider></GuestCartProvider></CartProvider>;
}

export default App;
